module.exports = __webpack_public_path__ + "static/media/icon-message--sent.e0c061fc.svg";